import { CSSProperties, get, Theme } from "theme-ui";

export const navigation: Theme["links"] = {
  nav: {
    variant: "styles.bodyMedium",
    textTransform: "none" as CSSProperties["textTransform"],
    textIndent: "26px",
    fontWeight: "400",
    color: "text.muted",
    lineHeight: "28px",
    height: "28px",
    flexShrink: 0,
    borderRadius: "6px",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    overflow: "hidden",
    ":focus": {
      outline: (theme) => `2px solid ${get(theme, "colors.whitelabel.accent")}`,
      zIndex: 10
    },
    cover: {
      cursor: "pointer"
    }
  },
  cover: {
    variant: "links.nav",
    textIndent: "24px"
  },
  quick: {
    variant: "links.nav",
    width: "unset",
    minWidth: "140px",
    padding: "unset",
    lineHeight: "32px",
    paddingRight: "12px"
  }
};
